import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'btp-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.css']
})
export class InputComponent implements OnInit {
  
  @Input() id: string;

  constructor() { }

  ngOnInit() {
  }

}
